export function commonFunc() {
}